const style = {
  tableRow: {
    cursor: 'pointer',
  },
  profileCell: {
    sx: {
      width: '250px',
    },
  },
  associatedCompanyCell: {
    sx: {
      width: '250px',
    },
  },
  associatedCompanyText: {
    style: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: 5,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '180px',
    },
  },
  associatedCompanyManual: {
    style: {
      borderRadius: 4,
      verticalAlign: 'middle',
    },
  },
  plainCell: {
    sx: {
      width: 128,
    },
  },
  statusCell: {
    sx: {
      width: 120,
    },
  },
  positionsAmountCell: {
    sx: {
      width: 0,
    },
  },
  dateCell: {
    sx: {
      width: '200px',
    },
  },
  menuCell: {
    sx: {
      padding: '0px',
      textAlign: 'center',
    },
  },
  chipCell: {
    variant: 'outlined',
  },
  box: {
    sx: {
      display: 'flex',
    },
  },
  'MuiTableRow-root': {
    '&: hover': {
      backgroundColor: 'rgba(80, 72, 229, 0.08)',
    },
  },
 
} as const;

export default style;
